import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgUtilModule } from 'projects/ng-util/src/public-api';

import { LoginComponent } from './login.page';
import { MaterialComponentsModule } from '../shared/material.module';
import { AuthService } from '../shared/services/auth.service';
import { FirstAccessComponent } from './first-access/first-access.page';
import { PipesModule } from '../shared/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';
import {NgModule} from "@angular/core";
import { BrandingService } from 'src/app/shared/services/branding.service';

@NgModule({
  declarations: [
    LoginComponent,
    FirstAccessComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgUtilModule,
    MaterialComponentsModule,
    PipesModule,
    IonicModule
  ],
  exports: [
    LoginComponent
  ],
  providers: [
    AuthService,
          BrandingService
  ]
})
export class LoginModule { }
